var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"menu-btns"}},_vm._l((_vm.menus),function(menu,idx){return _c('div',{key:idx},[(idx !== 2)?_c('menu-btn',{attrs:{"iconData":menu,"tooltipPos":_vm.defTooltipPos}}):(idx === 2)?_c('editor-sub-menu',{attrs:{"iconData":menu,"subMenuData":menu.submenus,"tooltipPos":_vm.defTooltipPos}}):_vm._e()],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }